import { IconReduce2Outline18 } from "nucleo-ui-outline-18"

import type { SlashCommandDefinition } from "../types"
import { iconClassName } from "../constants"

export const detailsListCommand: SlashCommandDefinition = {
	key: "details-list",
	title: "Collapsible section",
	icon: <IconReduce2Outline18 strokeWidth={1.75} className={iconClassName} />,
	command: ({ editor, range }) => {
		editor.chain().focus().deleteRange(range).setDetails().run()
	},
	group: "lists",
}
